import { RAW_ANNOTATION_TAG_NAMES } from "@perceptron/core/types";

const NAMES = RAW_ANNOTATION_TAG_NAMES.join("|");

/**
 * The name must end at whitespace, `/` or `>`: a word boundary alone would let `<clip-path>` or
 * `<collection-item>` count as an annotation tag.
 */
const END_OF_NAME = "(?=[\\s/>])";

/** Matches an opening or closing annotation tag anywhere in raw model text. */
export const ANNOTATION_TAG_PATTERN = new RegExp(`<\\s*/?\\s*(${NAMES})${END_OF_NAME}`, "i");

/** Matches text that starts with an opening annotation tag. */
export const ANNOTATION_OPENING_PATTERN = new RegExp(`^<\\s*(${NAMES})${END_OF_NAME}`, "i");
